import {Dispatcher} from "../../../stem-core/src/base/Dispatcher";
import {NOOP_FUNCTION} from "../../../stem-core/src/base/Utils";


export class AddressController extends Dispatcher {
    addressSectionState = null;
    selectedAddress = null;
    continueLabel = "";
    onSelectSuccess = NOOP_FUNCTION;
    onSelectCancel = NOOP_FUNCTION;

    update(props) {
        Object.assign(this, props);
        this.dispatch();
    }
}

export const addressController = new AddressController();
